module.exports = __webpack_public_path__ + "static/disability_card_img2@2x-20103af9337ef5a1623eb0628b9d5cc4.jpg";